import React from 'react';
import './TitleLogo.css';

const TitleLogo = () => {
  return (
    <div className="title-logo">
      <img 
        src="/polyanimals.png" 
        alt="Polyanimals" 
        className="polyanimals-logo"
      />
    </div>
  );
};

export default TitleLogo;
